// Suggestion data for autocomplete functionality
export const SUGGESTION_DATA = {
  skills: [
    // Programming Languages
    'JavaScript', 'TypeScript', 'Python', 'Java', 'C++', 'C#', 'C', 'PHP', 'Ruby', 'Go', 'Rust', 
    'Swift', 'Kotlin', 'Scala', 'R', 'MATLAB', 'SAS', 'Julia', 'Perl', 'Lua', 'Dart', 'Elixir',
    'Haskell', 'F#', 'Clojure', 'Erlang', 'Assembly', 'COBOL', 'Fortran', 'VB.NET', 'Objective-C',
    'Shell Scripting', 'Bash', 'PowerShell', 'VBA', 'SQL', 'PL/SQL', 'T-SQL',
    
    // Web Technologies - Frontend
    'HTML5', 'CSS3', 'SCSS', 'SASS', 'LESS', 'React', 'React Native', 'Next.js', 'Gatsby',
    'Angular', 'AngularJS', 'Vue.js', 'Nuxt.js', 'Svelte', 'SvelteKit', 'Ember.js', 'Backbone.js',
    'jQuery', 'D3.js', 'Three.js', 'WebGL', 'WebAssembly', 'Progressive Web Apps',
    'Responsive Design', 'Cross-browser Compatibility', 'Web Accessibility', 'SEO',
    
    // Web Technologies - Backend
    'Node.js', 'Express.js', 'Koa.js', 'Nest.js', 'Django', 'Flask', 'FastAPI', 'Tornado',
    'Spring Boot', 'Spring Framework', 'Hibernate', 'ASP.NET Core', 'ASP.NET MVC', 
    'Laravel', 'Symfony', 'CodeIgniter', 'Ruby on Rails', 'Sinatra', 'Gin', 'Echo',
    'Fiber', 'Phoenix', 'Rocket', 'Actix', 'Axum',
    
    // CSS Frameworks & UI Libraries
    'Bootstrap', 'Tailwind CSS', 'Bulma', 'Foundation', 'Semantic UI', 'Material-UI', 'MUI',
    'Ant Design', 'Chakra UI', 'Mantine', 'React Bootstrap', 'Styled Components', 'Emotion',
    
    // Databases - Relational
    'MySQL', 'PostgreSQL', 'SQLite', 'Oracle Database', 'Microsoft SQL Server', 'MariaDB',
    'IBM DB2', 'Teradata', 'Amazon RDS', 'Azure SQL Database', 'Google Cloud SQL',
    
    // Databases - NoSQL
    'MongoDB', 'Redis', 'Cassandra', 'DynamoDB', 'CouchDB', 'Neo4j', 'ArangoDB',
    'Amazon DocumentDB', 'Firebase Firestore', 'Apache HBase', 'InfluxDB', 'TimescaleDB',
    
    // Search & Analytics Databases
    'Elasticsearch', 'Apache Solr', 'Amazon OpenSearch', 'Algolia', 'Sphinx',
    
    // Cloud Platforms
    'Amazon Web Services (AWS)', 'Microsoft Azure', 'Google Cloud Platform (GCP)',
    'IBM Cloud', 'Oracle Cloud', 'Alibaba Cloud', 'DigitalOcean', 'Linode', 'Vultr',
    'Heroku', 'Netlify', 'Vercel', 'Railway', 'PlanetScale', 'Supabase', 'Firebase',
    
    // AWS Services
    'EC2', 'S3', 'Lambda', 'RDS', 'DynamoDB', 'CloudFormation', 'CloudWatch', 'IAM',
    'API Gateway', 'ECS', 'EKS', 'SageMaker', 'Redshift', 'EMR', 'Kinesis', 'SNS', 'SQS',
    
    // Azure Services
    'Azure Virtual Machines', 'Azure Storage', 'Azure Functions', 'Azure SQL Database',
    'Azure Cosmos DB', 'Azure Kubernetes Service', 'Azure DevOps', 'Azure Machine Learning',
    
    // Google Cloud Services
    'Compute Engine', 'Cloud Storage', 'Cloud Functions', 'Cloud SQL', 'BigQuery',
    'Google Kubernetes Engine', 'Cloud AI Platform', 'Cloud Dataflow', 'Cloud Pub/Sub',
    
    // DevOps & CI/CD
    'Docker', 'Kubernetes', 'Jenkins', 'GitLab CI/CD', 'GitHub Actions', 'Azure DevOps',
    'CircleCI', 'Travis CI', 'TeamCity', 'Bamboo', 'ArgoCD', 'Flux', 'Spinnaker',
    'Terraform', 'Ansible', 'Chef', 'Puppet', 'SaltStack', 'Pulumi', 'CloudFormation',
    'Helm', 'Istio', 'Prometheus', 'Grafana', 'ELK Stack', 'Splunk', 'Datadog', 'New Relic',
    
    // Version Control & Collaboration
    'Git', 'GitHub', 'GitLab', 'Bitbucket', 'Azure Repos', 'Subversion (SVN)', 'Mercurial',
    'Perforce', 'Bazaar', 'Jira', 'Confluence', 'Trello', 'Asana', 'Monday.com', 'Notion',
    'Slack', 'Microsoft Teams', 'Discord', 'Zoom', 'Google Meet', 'WebEx',
    
    // Design & UX Tools
    'Figma', 'Sketch', 'Adobe XD', 'InVision', 'Zeplin', 'Marvel', 'Principle', 'Framer',
    'Adobe Creative Suite', 'Photoshop', 'Illustrator', 'After Effects', 'Premiere Pro',
    'Canva', 'GIMP', 'Inkscape', 'Blender', 'Maya', 'Cinema 4D',
    
    // API Technologies
    'REST API', 'GraphQL', 'gRPC', 'SOAP', 'WebSockets', 'Server-Sent Events',
    'OpenAPI/Swagger', 'Postman', 'Insomnia', 'Apollo GraphQL', 'Relay',
    
    // Machine Learning & AI Frameworks
    'TensorFlow', 'PyTorch', 'Keras', 'Scikit-learn', 'XGBoost', 'LightGBM', 'CatBoost',
    'Hugging Face Transformers', 'spaCy', 'NLTK', 'OpenCV', 'Detectron2', 'YOLO',
    'Apache MXNet', 'Caffe', 'Theano', 'JAX', 'MLX', 'ONNX', 'TensorRT', 'OpenVINO',
    
    // Data Science & Analytics Tools
    'Pandas', 'NumPy', 'Matplotlib', 'Seaborn', 'Plotly', 'Bokeh', 'Altair', 'Streamlit',
    'Jupyter Notebooks', 'JupyterLab', 'Google Colab', 'Kaggle Notebooks', 'Databricks',
    'Apache Spark', 'Apache Kafka', 'Apache Airflow', 'Apache Beam', 'Dask', 'Ray',
    'Tableau', 'Power BI', 'Looker', 'QlikView', 'D3.js', 'Observable', 'Metabase',
    
    // Big Data Technologies
    'Hadoop', 'HDFS', 'MapReduce', 'Hive', 'Pig', 'HBase', 'Impala', 'Presto', 'Trino',
    'Apache Storm', 'Apache Flink', 'Apache Samza', 'Elasticsearch', 'Logstash', 'Kibana',
    'Apache Druid', 'ClickHouse', 'Apache Pinot', 'Snowflake', 'BigQuery', 'Redshift',
    
    // Mobile Development
    'React Native', 'Flutter', 'Xamarin', 'Ionic', 'Cordova', 'PhoneGap', 'NativeScript',
    'Android Studio', 'Xcode', 'SwiftUI', 'UIKit', 'Android SDK', 'iOS SDK',
    'Expo', 'Capacitor', 'Unity', 'Unreal Engine', 'Cocos2d',
    
    // Game Development
    'Unity', 'Unreal Engine', 'Godot', 'GameMaker Studio', 'Construct 3', 'RPG Maker',
    'Phaser', 'Three.js', 'Babylon.js', 'A-Frame', 'PlayCanvas', 'Defold',
    
    // Blockchain & Web3
    'Solidity', 'Web3.js', 'Ethers.js', 'Truffle', 'Hardhat', 'Ganache', 'MetaMask',
    'Smart Contracts', 'DeFi', 'NFTs', 'IPFS', 'Ethereum', 'Bitcoin', 'Hyperledger',
    
    // Finance & Trading Tools
    'Bloomberg Terminal', 'Reuters Eikon', 'FactSet', 'Morningstar Direct', 'Capital IQ',
    'Python for Finance', 'R for Finance', 'MATLAB Financial Toolbox', 'VBA for Finance',
    'MetaTrader', 'TradingView', 'Interactive Brokers API', 'Alpha Architect', 'Quantlib',
    'Risk Management Tools', 'Portfolio Management Systems', 'Algorithmic Trading',
    
    // Financial Modeling & Analysis
    'Excel Advanced Functions', 'Financial Modeling', 'Valuation Models', 'Monte Carlo Simulation',
    'VaR Models', 'Credit Risk Models', 'Options Pricing Models', 'Fixed Income Analytics',
    'Derivatives Pricing', 'Portfolio Optimization', 'Backtesting', 'Performance Attribution',
    
    // Cybersecurity Tools
    'Wireshark', 'Nmap', 'Metasploit', 'Burp Suite', 'OWASP ZAP', 'Kali Linux',
    'Nessus', 'OpenVAS', 'Splunk', 'IBM QRadar', 'FireEye', 'CrowdStrike',
    'Penetration Testing', 'Vulnerability Assessment', 'Incident Response',
    
    // Testing & Quality Assurance
    'Jest', 'Mocha', 'Chai', 'Jasmine', 'Cypress', 'Selenium', 'Playwright', 'Puppeteer',
    'TestNG', 'JUnit', 'Mockito', 'PyTest', 'RSpec', 'Cucumber', 'Postman', 'Newman',
    'Load Testing', 'Performance Testing', 'Security Testing', 'Accessibility Testing',
    
    // Project Management & Methodologies
    'Agile', 'Scrum', 'Kanban', 'Lean', 'Six Sigma', 'Waterfall', 'DevOps', 'GitOps',
    'Project Management Professional (PMP)', 'Certified Scrum Master (CSM)', 'SAFe',
    'Microsoft Project', 'Smartsheet', 'ClickUp', 'Linear', 'Height',
    
    // Soft Skills - Leadership & Management
    'Leadership', 'Team Management', 'People Management', 'Strategic Planning', 'Decision Making',
    'Delegation', 'Performance Management', 'Coaching', 'Mentoring', 'Change Management',
    'Conflict Resolution', 'Cross-functional Collaboration', 'Stakeholder Management',
    'Budget Management', 'Resource Planning', 'Vendor Management',
    
    // Soft Skills - Communication
    'Verbal Communication', 'Written Communication', 'Technical Writing', 'Documentation',
    'Public Speaking', 'Presentation Skills', 'Storytelling', 'Active Listening',
    'Cross-cultural Communication', 'Client Communication', 'Meeting Facilitation',
    'Training and Development', 'Knowledge Transfer',
    
    // Soft Skills - Problem Solving & Analysis
    'Problem Solving', 'Critical Thinking', 'Analytical Thinking', 'Creative Problem Solving',
    'Root Cause Analysis', 'Data-driven Decision Making', 'Systems Thinking',
    'Process Improvement', 'Innovation', 'Design Thinking', 'Research Skills',
    
    // Soft Skills - Personal Effectiveness
    'Time Management', 'Prioritization', 'Organization', 'Self-motivation', 'Adaptability',
    'Flexibility', 'Resilience', 'Stress Management', 'Learning Agility', 'Growth Mindset',
    'Attention to Detail', 'Quality Focus', 'Continuous Improvement', 'Self-reflection',
    
    // Soft Skills - Collaboration & Teamwork
    'Teamwork', 'Collaboration', 'Interpersonal Skills', 'Empathy', 'Emotional Intelligence',
    'Cultural Awareness', 'Inclusion', 'Networking', 'Relationship Building', 'Trust Building',
    'Feedback Giving and Receiving', 'Peer Review', 'Code Review',
    
    // Business & Domain Skills
    'Business Analysis', 'Requirements Gathering', 'Process Mapping', 'Gap Analysis',
    'Market Research', 'Competitive Analysis', 'Customer Experience', 'User Experience (UX)',
    'Product Management', 'Product Strategy', 'Go-to-Market Strategy', 'Pricing Strategy',
    'Sales', 'Customer Success', 'Account Management', 'Negotiation', 'Contract Management',
    
    // Industry-Specific Skills
    'Healthcare IT', 'FinTech', 'EdTech', 'E-commerce', 'SaaS', 'Enterprise Software',
    'Regulatory Compliance', 'GDPR', 'HIPAA', 'SOX', 'PCI DSS', 'ISO 27001',
    'Financial Services', 'Banking', 'Insurance', 'Investment Management', 'Trading',
    'Supply Chain', 'Manufacturing', 'Retail', 'Media and Entertainment', 'Gaming'
],
  
  schools: [
    // Top 100 US Universities
    'Harvard University', 'Drew University', 'Stanford University', 'Massachusetts Institute of Technology', 
    'Yale University', 'Princeton University', 'Columbia University', 'University of Pennsylvania',
    'California Institute of Technology', 'University of Chicago', 'Duke University',
    'Northwestern University', 'Johns Hopkins University', 'Dartmouth College', 'Brown University',
    'Cornell University', 'University of California, Berkeley', 'University of California, Los Angeles',
    'Vanderbilt University', 'Rice University', 'Washington University in St. Louis',
    'University of Notre Dame', 'Emory University', 'Georgetown University', 'Carnegie Mellon University',
    'University of Virginia', 'University of Southern California', 'University of Michigan',
    'Wake Forest University', 'University of North Carolina at Chapel Hill', 'New York University',
    'University of California, San Diego', 'Lehigh University', 'University of Florida', 'University of Rochester',
    'Boston College', 'Georgia Institute of Technology', 'University of California, Irvine',
    'University of California, Davis', 'Case Western Reserve University', 'University of Wisconsin-Madison',
    'Boston University', 'Brandeis University', 'College of William & Mary', 'Tulane University',
    'University of Illinois at Urbana-Champaign', 'University of Texas at Austin', 'Northeastern University',
    'University of Georgia', 'University of California, Santa Barbara', 'Villanova University',
    'University of Miami', 'Tufts University', 'Ohio State University', 'University of Washington',
    'Pepperdine University', 'University of Connecticut', 'Clemson University', 'University of Maryland, College Park',
    'Purdue University', 'Syracuse University', 'University of Pittsburgh', 'Rutgers University',
    'University of Minnesota', 'Michigan State University', 'University of Delaware', 'Pennsylvania State University',
    'Florida State University', 'University of California, Santa Cruz', 'Indiana University Bloomington',
    'University of Iowa', 'Texas A&M University', 'Virginia Tech', 'University of Vermont',
    'University of Colorado Boulder', 'University of California, Riverside', 'University of Massachusetts Amherst',
    'University of New Hampshire', 'University of Arizona', 'Arizona State University', 'Auburn University',
    'University of Alabama', 'University of Kansas', 'University of Missouri', 'University of Nebraska-Lincoln',
    'Iowa State University', 'University of Oklahoma', 'University of Arkansas', 'University of Kentucky',
    'Louisiana State University', 'University of Mississippi', 'University of Tennessee', 'University of South Carolina',
    'North Carolina State University', 'University of Utah', 'University of Oregon', 'Oregon State University',
    'Washington State University', 'University of Nevada, Las Vegas', 'University of Hawaii at Manoa',
    'University of Alaska Fairbanks', 'University of Maine', 'University of Rhode Island', 'University of Montana',
    'University of Wyoming', 'University of North Dakota', 'University of South Dakota', 'University of Idaho',
    'Colorado State University', 'New Mexico State University', 'University of New Mexico', 'Utah State University',
    'Boise State University', 'Montana State University', 'University of Denver', 'Marquette University',
    'DePaul University', 'Loyola University Chicago', 'University of Dayton', 'Xavier University',

    // All New York Universities and Colleges
    'Columbia University', 'New York University', 'Cornell University', 'University at Buffalo (SUNY)',
    'Stony Brook University (SUNY)', 'University at Albany (SUNY)', 'Binghamton University (SUNY)',
    'Syracuse University', 'Rochester Institute of Technology', 'University of Rochester',
    'Rensselaer Polytechnic Institute', 'Fordham University', 'Yeshiva University', 'The New School',
    'Pace University', 'St. John\'s University', 'Hofstra University', 'Adelphi University',
    'Long Island University', 'Manhattan College', 'Iona University', 'Marist College',
    'Siena College', 'Union College', 'Clarkson University', 'St. Lawrence University',
    'Colgate University', 'Hamilton College', 'Vassar College', 'Barnard College',
    'Sarah Lawrence College', 'Purchase College (SUNY)', 'New Paltz (SUNY)', 'Oneonta (SUNY)',
    'Plattsburgh (SUNY)', 'Potsdam (SUNY)', 'Oswego (SUNY)', 'Cortland (SUNY)',
    'Geneseo (SUNY)', 'Brockport (SUNY)', 'Fredonia (SUNY)', 'Buffalo State College (SUNY)',
    'Old Westbury (SUNY)', 'Farmingdale State College (SUNY)', 'Maritime College (SUNY)',
    'College of Environmental Science and Forestry (SUNY)', 'Fashion Institute of Technology (SUNY)',
    'Cooper Union', 'Pratt Institute', 'Parsons School of Design', 'School of Visual Arts',
    'The Juilliard School', 'Manhattan School of Music', 'New York Institute of Technology',
    'St. Francis College', 'Brooklyn College (CUNY)', 'Queens College (CUNY)', 'Hunter College (CUNY)',
    'City College of New York (CUNY)', 'Baruch College (CUNY)', 'John Jay College (CUNY)',
    'York College (CUNY)', 'Lehman College (CUNY)', 'Staten Island College (CUNY)',
    'Medgar Evers College (CUNY)', 'New York City College of Technology (CUNY)',
    'Kingsborough Community College (CUNY)', 'LaGuardia Community College (CUNY)',
    'Queensborough Community College (CUNY)', 'Bronx Community College (CUNY)',
    'Borough of Manhattan Community College (CUNY)', 'Guttman Community College (CUNY)',
    'Hostos Community College (CUNY)', 'Stella and Charles Guttman Community College (CUNY)',

    // New York Community Colleges (Non-CUNY)
    'Nassau Community College', 'Suffolk County Community College', 'Westchester Community College',
    'Orange County Community College', 'Dutchess Community College', 'Ulster County Community College',
    'Sullivan County Community College', 'Columbia-Greene Community College', 'Fulton-Montgomery Community College',
    'Schenectady County Community College', 'Hudson Valley Community College', 'Adirondack Community College',
    'North Country Community College', 'Clinton Community College', 'Essex County Community College',
    'Franklin County Community College', 'Mohawk Valley Community College', 'Herkimer County Community College',
    'Onondaga Community College', 'Cayuga Community College', 'Finger Lakes Community College',
    'Monroe Community College', 'Genesee Community College', 'Livingston County Community College',
    'Alfred State College', 'Broome Community College', 'Tompkins Cortland Community College',
    'Corning Community College', 'Elmira College', 'Jamestown Community College',
    'Cattaraugus-Allegany Community College', 'Erie Community College', 'Niagara County Community College',

    // New York Private Colleges and Specialized Schools
    'Webb Institute', 'United States Military Academy', 'Culinary Institute of America',
    'Albany College of Pharmacy and Health Sciences', 'Albany Law School', 'Albany Medical College',
    'Bard College', 'Canisius College', 'Cazenovia College', 'Colgate Rochester Crozer Divinity School',
    'College of Mount Saint Vincent', 'Concordia College', 'Daemen University', 'Dominican College',
    'D\'Youville University', 'Elmira College', 'Eugene Lang College', 'Excelsior College',
    'Five Towns College', 'Hartwick College', 'Hilbert College', 'Hobart and William Smith Colleges',
    'Houghton College', 'Ithaca College', 'Keuka College', 'Le Moyne College', 'Manhattanville College',
    'Marymount Manhattan College', 'Mercy College', 'Molloy College', 'Mount Saint Mary College',
    'Nazareth College', 'New York Law School', 'Niagara University', 'Nyack College',
    'Pace University', 'Roberts Wesleyan College', 'Rochester Institute of Technology',
    'The Sage Colleges', 'St. Bonaventure University', 'St. Fisher College', 'St. Thomas Aquinas College',
    'Skidmore College', 'Teachers College Columbia University', 'Touro College', 'Utica College',
    'Wagner College', 'Wells College',


        // C9 League (Top Tier)
        'Tsinghua University',
        'Peking University', 
        'Fudan University',
        'Shanghai Jiao Tong University',
        'Zhejiang University',
        'University of Science and Technology of China',
        'Nanjing University',
        'Harbin Institute of Technology',
        'Xi\'an Jiaotong University',
    
        // Top Engineering & Technology Universities
        'Beihang University',
        'Beijing Institute of Technology',
        'Northwestern Polytechnical University',
        'Tianjin University',
        'Southeast University',
        'Dalian University of Technology',
        'University of Electronic Science and Technology of China',
        'Xidian University',
        'Beijing University of Posts and Telecommunications',
        'Northeast University',
        'China University of Mining and Technology',
        'Nanjing University of Aeronautics and Astronautics',
        'Nanjing University of Science and Technology',
        'Beijing University of Chemical Technology',
        'East China University of Science and Technology',
        'Beijing Jiaotong University',
        'Hohai University',
    
        // Comprehensive Universities
        'Sun Yat-sen University',
        'Wuhan University',
        'Sichuan University',
        'Central South University',
        'Huazhong University of Science and Technology',
        'South China University of Technology',
        'Tongji University',
        'Nankai University',
        'Beijing Normal University',
        'East China Normal University',
        'Lanzhou University',
        'Ocean University of China',
        'China Agricultural University',
        'Beijing Forestry University',
        'Chongqing University',
        'Southwest University',
        'Yunnan University',
        'Xinjiang University',
        'Shihezi University',
        'Tibet University',
        'Inner Mongolia University',
        'Guangxi University',
        'Hainan University',
        'Yanbian University',
        'Ningxia University',
        'Qinghai University',
        'Chang\'an University',
        'Shaanxi Normal University',
        'Northwest University',
        'Northwest A&F University',
    
        // Finance & Economics Universities
        'Shanghai University of Finance and Economics',
        'Central University of Finance and Economics',
        'University of International Business and Economics',
        'Southwest University of Finance and Economics',
        'Northeastern University of Finance and Economics',
        'Shanghai University of International Business and Economics',
        'Capital University of Economics and Business',
        'Jiangxi University of Finance and Economics',
        'Zhongnan University of Economics and Law',
        'Dongbei University of Finance and Economics',
    
        // Political Science & Law Universities
        'China University of Political Science and Law',
        'East China University of Political Science and Law',
        'Southwest University of Political Science and Law',
        'Northwest University of Political Science and Law',
        'China Foreign Affairs University',
    
        // Language & International Studies
        'Beijing Foreign Studies University',
        'Shanghai International Studies University',
        'Beijing Language and Culture University',
    
        // Media & Arts Universities
        'Communication University of China',
        'China Media University',
        'Beijing Film Academy',
        'Central Academy of Fine Arts',
        'China Academy of Art',
    
        // Music Conservatories
        'Central Conservatory of Music',
        'Shanghai Conservatory of Music',
        'China Conservatory of Music',
    
        // Sports Universities
        'Beijing Sport University',
        'Shanghai University of Sport',
        'Chengdu Sport University',
    
        // Medical Universities
        'Capital Medical University',
        'China Medical University',
        'Southern Medical University',
        'Harbin Medical University',
        'China Pharmaceutical University',
        'Beijing University of Chinese Medicine',
        'Shanghai University of Traditional Chinese Medicine',
        'Guangzhou University of Chinese Medicine',
        'Tianjin University of Traditional Chinese Medicine',
        'Nanjing University of Chinese Medicine',
    
        // Military Universities
        'Chinese People\'s Liberation Army National Defense University',
        'National University of Defense Technology',
        'Air Force Engineering University',
        'Naval University of Engineering',
        'Army Engineering University',
        'Rocket Force University of Engineering',
        'Information Engineering University',
    
        // New & Innovative Universities
        'Shenzhen University',
        'Southern University of Science and Technology',
        'Westlake University',
        'ShanghaiTech University',
    
        // Joint Venture Universities
        'Chinese University of Hong Kong, Shenzhen',
        'New York University Shanghai',
        'Duke Kunshan University',
        'Xi\'an Jiaotong-Liverpool University',
        'University of Nottingham Ningbo China',
    
        // Branch Campuses
        'Beijing Institute of Technology, Zhuhai',
        'Harbin Institute of Technology, Shenzhen',
    
        // Additional Comprehensive Universities
        'Jilin University',
        'Xiamen University',
        'Hunan University',
        'Daqing Petroleum Institute',
        'China University of Petroleum',
        'Beijing University of Technology',
        'Shanghai University',
        'Nanjing University of Posts and Telecommunications',
        'Hefei University of Technology',
        'Taiyuan University of Technology',
        'Kunming University of Science and Technology',
        'Guangdong University of Technology',
        'Shantou University',
        'Soochow University',
        'Yangzhou University',
        'Nantong University',
        'Jiangsu University',
        'Zhejiang University of Technology',
        'Hangzhou Dianzi University',
        'China Jiliang University',
        'Wenzhou University',
        'Ningbo University',
        'Fujian Normal University',
        'Huaqiao University',
        'Jimei University',
        'Shandong University',
        'China University of Petroleum (East China)',
        'Qingdao University',
        'Yantai University',
        'Ludong University',
        'Henan University',
        'Zhengzhou University',
        'Hebei University',
        'Hebei University of Technology',
        'North China Electric Power University',
        'Hebei Normal University',
        'Shanxi University',
        'Taiyuan University of Science and Technology',
        'Inner Mongolia University of Science and Technology',
        'Liaoning University',
        'Shenyang University of Technology',
        'Northeastern University',
        'Dalian Maritime University',
        'Dalian University of Foreign Languages',
    
        // Additional Medical Universities
        'Beijing University of Traditional Chinese Medicine',
        'Tianjin Medical University',
        'Hebei Medical University',
        'Shanxi Medical University',
        'Inner Mongolia Medical University',
        'China Medical University (Liaoning)',
        'Dalian Medical University',
        'Jilin University Norman Bethune Health Science Center',
        'Harbin Medical University',
        'Heilongjiang University of Chinese Medicine',
        'Fudan University Shanghai Medical College',
        'Shanghai Jiao Tong University School of Medicine',
        'Nanjing Medical University',
        'Xuzhou Medical University',
        'Nantong University Medical School',
        'Zhejiang University School of Medicine',
        'Wenzhou Medical University',
        'Anhui Medical University',
        'Fujian Medical University',
        'Nanchang University Medical College',
        'Shandong University School of Medicine',
        'Weifang Medical University',
        'Zhengzhou University Medical College',
        'Wuhan University School of Medicine',
        'Huazhong University of Science and Technology Tongji Medical College',
        'Central South University Xiangya School of Medicine',
        'Sun Yat-sen University School of Medicine',
        'Guangzhou Medical University',
        'Guangxi Medical University',
        'Hainan Medical University',
        'Chongqing Medical University',
        'Sichuan University West China School of Medicine',
        'Kunming Medical University',
        'Xi\'an Jiaotong University Health Science Center',
        'Lanzhou University School of Medicine',
    
        // Additional Normal Universities
        'Capital Normal University',
        'Tianjin Normal University',
        'Hebei Normal University',
        'Shanxi Normal University',
        'Inner Mongolia Normal University',
        'Liaoning Normal University',
        'Shenyang Normal University',
        'Northeast Normal University',
        'Harbin Normal University',
        'Shanghai Normal University',
        'Jiangsu Normal University',
        'Nanjing Normal University',
        'Zhejiang Normal University',
        'Hangzhou Normal University',
        'Anhui Normal University',
        'Fujian Normal University',
        'Jiangxi Normal University',
        'Shandong Normal University',
        'Qufu Normal University',
        'Henan Normal University',
        'Hubei Normal University',
        'Hunan Normal University',
        'South China Normal University',
        'Guangxi Normal University',
        'Hainan Normal University',
        'Sichuan Normal University',
        'Yunnan Normal University',
        'Shaanxi Normal University',
        'Northwest Normal University',
        'Qinghai Normal University',
        'Xinjiang Normal University',
    
        // Additional Agricultural Universities
        'Northeast Agricultural University',
        'Nanjing Agricultural University',
        'Huazhong Agricultural University',
        'South China Agricultural University',
        'Sichuan Agricultural University',
        'Northwest A&F University',
        'Beijing Forestry University',
        'Northeast Forestry University',
        'Nanjing Forestry University',
        'Central South University of Forestry and Technology',
        'Southwest Forestry University',
    
        // Additional Technology & Engineering Universities
        'University of Science and Technology Beijing',
        'Beijing Information Science and Technology University',
        'Beijing University of Civil Engineering and Architecture',
        'North China University of Technology',
        'Tianjin University of Science and Technology',
        'Tianjin University of Technology',
        'Hebei University of Science and Technology',
        'Shenyang University of Technology',
        'Shenyang Aerospace University',
        'Shenyang Ligong University',
        'Changchun University of Technology',
        'Changchun University of Science and Technology',
        'Harbin University of Science and Technology',
        'Harbin Engineering University',
        'Shanghai Institute of Technology',
        'Nanjing University of Technology',
        'Jiangsu University of Science and Technology',
        'Zhejiang University of Science and Technology',
        'Anhui University of Science and Technology',
        'Hefei University of Technology',
        'Wuhan University of Technology',
        'Wuhan Institute of Technology',
        'Hubei University of Technology',
        'Changsha University of Science and Technology',
        'Hunan University of Science and Technology',
        'Guangdong University of Technology',
        'Guilin University of Electronic Technology',
        'Chongqing University of Technology',
        'Southwest University of Science and Technology',
        'Xi\'an University of Technology',
        'Xi\'an University of Science and Technology',
        'Lanzhou University of Technology'
],
  
courses: [
  // Core Computer Science Courses
  'Introduction to Computer Science', 'Programming Fundamentals', 'Data Structures and Algorithms', 
  'Object-Oriented Programming', 'Database Systems', 'Computer Networks', 'Operating Systems', 
  'Software Engineering', 'Computer Architecture', 'Programming Languages', 'Compilers', 
  'Theory of Computation', 'Discrete Mathematics for CS', 'Computer Systems', 'Systems Programming',
  'Software Design Patterns', 'Algorithm Analysis', 'Advanced Data Structures', 'Distributed Systems',
  'Computer Security', 'Cybersecurity', 'Network Security', 'Information Security',
  'Software Testing', 'Software Project Management', 'Agile Development', 'DevOps',
  
  // Web and Mobile Development
  'Web Development', 'Frontend Development', 'Backend Development', 'Full Stack Development',
  'Mobile App Development', 'iOS Development', 'Android Development', 'React Native Development',
  'Web Design', 'User Interface Design', 'User Experience Design', 'Responsive Web Design',
  'JavaScript Programming', 'Python Web Development', 'Node.js Development', 'API Development',
  
  // Machine Learning and AI Core Courses
  'Machine Learning', 'Artificial Intelligence', 'Deep Learning', 'Neural Networks',
  'Computer Vision', 'Natural Language Processing', 'Reinforcement Learning', 'Pattern Recognition',
  'Machine Learning Algorithms', 'Advanced Machine Learning', 'AI Ethics', 'Robotics',
  'Knowledge Representation', 'Expert Systems', 'Intelligent Agents', 'Search Algorithms',
  'Bayesian Networks', 'Genetic Algorithms', 'Fuzzy Logic', 'Swarm Intelligence',
  'Large Language Models', 'Generative AI', 'AI Safety', 'Explainable AI',
  'MLOps', 'Model Deployment', 'AI Product Management', 'Conversational AI',
  
  // Data Science and Analytics
  'Data Science', 'Big Data Analytics', 'Data Mining', 'Business Intelligence',
  'Data Visualization', 'Statistical Computing', 'Predictive Analytics', 'Time Series Analysis',
  'A/B Testing', 'Experimental Design', 'Causal Inference', 'Statistical Modeling',
  'Data Warehousing', 'ETL Processes', 'Data Pipeline Design', 'Stream Processing',
  'Apache Spark', 'Hadoop Ecosystem', 'NoSQL Databases', 'Data Engineering',
  'Feature Engineering', 'Model Selection', 'Cross Validation', 'Ensemble Methods',
  'Dimensionality Reduction', 'Clustering Algorithms', 'Association Rule Mining',
  'Text Analytics', 'Social Network Analysis', 'Web Analytics', 'Customer Analytics',
  
  // Programming Languages and Tools
  'Python Programming', 'R Programming', 'Java Programming', 'C++ Programming',
  'C Programming', 'JavaScript', 'SQL', 'Scala Programming', 'Go Programming',
  'Rust Programming', 'Swift Programming', 'Kotlin Programming', 'TypeScript',
  'MATLAB Programming', 'SAS Programming', 'Tableau', 'Power BI', 'Excel VBA',
  'Git Version Control', 'Linux/Unix Systems', 'Docker', 'Kubernetes',
  
  // Cloud Computing and Infrastructure
  'Cloud Computing', 'Amazon Web Services (AWS)', 'Microsoft Azure', 'Google Cloud Platform',
  'Cloud Architecture', 'Serverless Computing', 'Microservices', 'Container Orchestration',
  'Infrastructure as Code', 'Cloud Security', 'Cloud Data Engineering', 'Cloud ML/AI Services',
  
  // Finance Core Courses
  'Corporate Finance', 'Investment Analysis', 'Financial Markets', 'Portfolio Management',
  'Risk Management', 'Derivatives', 'Fixed Income Securities', 'Equity Valuation',
  'Financial Modeling', 'Mergers and Acquisitions', 'International Finance', 'Financial Planning',
  'Real Estate Finance', 'Behavioral Finance', 'Financial Economics', 'Capital Markets',
  'Credit Analysis', 'Asset Management', 'Wealth Management', 'Insurance and Risk',
  'Banking and Financial Institutions', 'Financial Regulation', 'ESG Investing',
  
  // Quantitative Finance and FinTech
  'Quantitative Finance', 'Algorithmic Trading', 'High-Frequency Trading', 'Options Pricing',
  'Stochastic Processes in Finance', 'Monte Carlo Methods in Finance', 'Credit Risk Modeling',
  'Market Risk Management', 'Operational Risk', 'Financial Engineering', 'Structured Products',
  'FinTech', 'Blockchain and Cryptocurrency', 'Digital Banking', 'Robo-Advisors',
  'Payment Systems', 'RegTech', 'InsurTech', 'Alternative Lending', 'Crowdfunding',
  'Financial Data Analytics', 'Trading Systems', 'Portfolio Optimization', 'Backtesting',
  
  // Mathematics for CS/DS/Finance
  'Calculus I', 'Calculus II', 'Calculus III', 'Multivariable Calculus', 'Linear Algebra',
  'Discrete Mathematics', 'Statistics', 'Probability Theory', 'Mathematical Statistics',
  'Bayesian Statistics', 'Multivariate Statistics', 'Nonparametric Statistics', 'Survival Analysis',
  'Stochastic Processes', 'Mathematical Finance', 'Actuarial Mathematics', 'Game Theory',
  'Optimization Theory', 'Convex Optimization', 'Linear Programming', 'Integer Programming',
  'Dynamic Programming', 'Numerical Analysis', 'Numerical Linear Algebra', 'Computational Mathematics',
  'Differential Equations', 'Partial Differential Equations', 'Mathematical Modeling',
  'Operations Research', 'Combinatorics', 'Graph Theory', 'Information Theory',
  
  // Business and Economics
  'Microeconomics', 'Macroeconomics', 'Econometrics', 'Business Economics', 'Managerial Economics',
  'Business Management', 'Strategic Management', 'Operations Management', 'Supply Chain Management',
  'Marketing', 'Digital Marketing', 'Marketing Analytics', 'Consumer Behavior',
  'Accounting', 'Financial Accounting', 'Managerial Accounting', 'Cost Accounting',
  'Entrepreneurship', 'Innovation Management', 'Venture Capital', 'Private Equity',
  'Project Management', 'Agile Project Management', 'Business Analytics', 'Business Intelligence',
  'Human Resources Management', 'Organizational Behavior', 'Leadership', 'Business Ethics',
  'International Business', 'Global Economics', 'Business Law', 'Intellectual Property',
  
  // Specialized Technical Courses
  'Computer Graphics', '3D Modeling and Animation', 'Game Development', 'Virtual Reality',
  'Augmented Reality', 'Human-Computer Interaction', 'Usability Engineering', 'Information Systems',
  'Enterprise Systems', 'ERP Systems', 'CRM Systems', 'Business Process Management',
  'Information Architecture', 'Knowledge Management', 'Decision Support Systems',
  'Recommender Systems', 'Search Engines', 'Information Retrieval', 'Semantic Web',
  'Bioinformatics', 'Computational Biology', 'Health Informatics', 'Medical Imaging',
  'GIS and Spatial Analysis', 'Remote Sensing', 'IoT Systems', 'Edge Computing',
  'Quantum Computing', 'Blockchain Technology', 'Smart Contracts', 'Cryptocurrency',
  
  // Research and Advanced Topics
  'Research Methods', 'Data Collection Methods', 'Survey Design', 'Interview Techniques',
  'Literature Review', 'Academic Writing', 'Technical Writing', 'Presentation Skills',
  'Ethics in Technology', 'Privacy and Data Protection', 'Algorithmic Bias', 'Fairness in AI',
  'Capstone Project', 'Senior Thesis', 'Independent Study', 'Internship',
  'Industry Collaboration', 'Open Source Contribution', 'Hackathon Participation'
],
  
  certificates: [
    
    // AWS Certifications
    'AWS Certified Solutions Architect', 'AWS Certified Developer', 'AWS Certified SysOps Administrator', 'AWS Certified DevOps Engineer', 'AWS Certified Security', 'AWS Certified Advanced Networking', 'AWS Certified Machine Learning', 'AWS Certified Database', 'AWS Certified Data Analytics',
    
    // Microsoft Certifications
    'Microsoft Certified: Azure Developer Associate', 'Microsoft Certified: Azure Solutions Architect Expert', 'Microsoft Certified: Azure DevOps Engineer Expert', 'Microsoft Certified: Azure Security Engineer Associate', 'Microsoft Certified: Azure Data Engineer Associate', 'Microsoft Certified: Azure AI Engineer Associate', 'Microsoft 365 Certified: Enterprise Administrator Expert', 'Microsoft 365 Certified: Security Administrator Associate',
    
    // Google Certifications
    'Google Cloud Professional Cloud Architect', 'Google Cloud Professional Data Engineer', 'Google Cloud Professional Cloud Developer', 'Google Cloud Professional Cloud Security Engineer', 'Google Cloud Professional Cloud Network Engineer', 'Google Cloud Professional Machine Learning Engineer', 'Google Cloud Professional Cloud DevOps Engineer', 'Google Cloud Professional Cloud Database Administrator',
    
    // Cisco Certifications
    'Cisco Certified Network Associate (CCNA)', 'Cisco Certified Network Professional (CCNP)', 'Cisco Certified Internetwork Expert (CCIE)', 'Cisco Certified DevNet Associate', 'Cisco Certified DevNet Professional', 'Cisco Certified CyberOps Associate', 'Cisco Certified Design Associate (CCDA)', 'Cisco Certified Design Professional (CCDP)',
    
    // CompTIA Certifications
    'CompTIA A+', 'CompTIA Network+', 'CompTIA Security+', 'CompTIA Linux+', 'CompTIA Cloud+', 'CompTIA CySA+', 'CompTIA PenTest+', 'CompTIA Project+', 'CompTIA IT Fundamentals+',
    
    // Project Management
    'Project Management Professional (PMP)', 'Certified Associate in Project Management (CAPM)', 'PRINCE2 Foundation', 'PRINCE2 Practitioner', 'Agile Certified Practitioner (PMI-ACP)', 'Certified ScrumMaster (CSM)', 'Professional Scrum Master (PSM)', 'SAFe Agilist', 'Kanban Management Professional (KMP)',
    
    // Data Science & Analytics
    'Certified Analytics Professional (CAP)', 'SAS Certified Data Scientist', 'IBM Data Science Professional Certificate', 'Google Data Analytics Professional Certificate', 'Microsoft Certified: Data Analyst Associate', 'Tableau Desktop Certified Associate', 'Tableau Desktop Certified Professional', 'Power BI Data Analyst Associate',
    
    // Security Certifications
    'Certified Information Systems Security Professional (CISSP)', 'Certified Ethical Hacker (CEH)', 'Certified Information Systems Auditor (CISA)', 'Certified Information Security Manager (CISM)', 'GIAC Security Essentials (GSEC)', 'GIAC Certified Incident Handler (GCIH)', 'GIAC Certified Intrusion Analyst (GCIA)', 'Offensive Security Certified Professional (OSCP)',
    
    // Programming & Development
    'Oracle Certified Professional, Java SE Programmer', 'Oracle Certified Professional, Java SE Developer', 'Microsoft Certified: Azure Developer Associate', 'Google Cloud Professional Cloud Developer', 'AWS Certified Developer', 'Red Hat Certified Engineer (RHCE)', 'Red Hat Certified System Administrator (RHCSA)', 'Linux Foundation Certified System Administrator (LFCS)', 'Linux Foundation Certified Engineer (LFCE)',
    
    // Database Certifications
    'Oracle Certified Professional, MySQL Database Administrator', 'Oracle Certified Professional, Oracle Database Administrator', 'Microsoft Certified: Azure Database Administrator Associate', 'MongoDB Certified Developer', 'MongoDB Certified Database Administrator', 'PostgreSQL Certified Associate', 'IBM Certified Database Administrator', 'SAP Certified Technology Associate',

    //Other
    'OSHA 10 (General Industry)',
 'OSHA 30 (General Industry)',
 'Powered Industrial Truck (Forklift) Operator Certification (OSHA 1910.178)',
 "Commercial Driver's License (CDL) Class A",
 "Commercial Driver's License (CDL) Class B",
 "Commercial Driver's License (CDL) Class C",
 'CDL Endorsement: H — Hazardous Materials',
 'CDL Endorsement: N — Tank Vehicles',
 'CDL Endorsement: X — Tank + Hazardous Materials',
 'CDL Endorsement: T — Double/Triple Trailers',
 'Hazmat Employee Training (49 CFR 172.704)',
 'TWIC — Transportation Worker Identification Credential',
 'OSHA 10 (General Industry)',
 'OSHA 30 (General Industry)',
 'NFPA 70E Electrical Safety Training',
 'Lockout/Tagout (LOTO) Training',
 'Confined Space Entry Training',
 'Fall Protection Training',
 'MEWP/Aerial Lift Operator Certification (ANSI A92)',
 'CMRT — Certified Maintenance & Reliability Technician',
 'CMRP — Certified Maintenance & Reliability Professional',
 'OSHA 10 (Construction)',
 'OSHA 30 (Construction)',
 'Scaffold User Certification',
 'Scaffold Competent Person',
 'Fall Protection Competent Person',
 'Trenching & Excavation Competent Person',
 'Silica Awareness/Competent Person (OSHA 1926.1153)',
 'Flagger/Traffic Control Certification',
 'Confined Space (Construction) Training',
 'Welding & Cutting Safety (OSHA 1926 Subpart J)',
 'Apprentice Plumber Registration (state/city)',
 'Journeyman Plumber License',
 'Master Plumber License',
 'ASSE 5110 Backflow Prevention Assembly Tester',
 'ASSE 6010 Medical Gas Systems Installer',
 'EPA Lead RRP — Renovation, Repair and Painting',
 'Apprentice Electrician Registration (state/city)',
 'Journeyman Electrician License',
 'Master Electrician License',
 'NFPA 70E Electrical Safety Training',
 'OSHA 10 (Construction)',
 'OSHA 30 (Construction)',
 'MEWP/Aerial Lift Operator Certification (ANSI A92)',
 'Lockout/Tagout (LOTO) Training',
 'EPA Section 608 Type I',
 'EPA Section 608 Type II',
 'EPA Section 608 Type III',
 'EPA Section 608 Universal',
 'NATE — Ready-to-Work Certificate',
 'NATE — Core & Specialty Certification',
 'R-410A Safety Training',
 'Brazing/Soldering Qualification',
 'OSHA 10 (General Industry)',
 'Responsible Alcohol Service Certification (e.g., TIPS / ServSafe Alcohol / State RBS)',
 'Allergen Awareness Certification (state/ANAB-recognized)',
 'CPR/First Aid Certification',
 'Food Handler Certificate (ANAB-accredited; e.g., ServSafe Food Handler)',
 'Certified Food Protection Manager (e.g., ServSafe Manager / NRFSP / StateFoodSafety CFPM)',
 'Allergen Awareness Certification (state/ANAB-recognized)',
 'HACCP Certification (manager/production kitchens)'
  ]
};

// Function to get suggestions based on input
export const getSuggestions = (input, type) => {

  if (!SUGGESTION_DATA[type]) return [];
  
  const raw = String(input ?? '').trim();
  if (!raw) {
    // Show first 10 suggestions when input is empty
    return SUGGESTION_DATA[type].slice(0, 10);
  }
  
  const searchTerm = raw.toLowerCase();
  return SUGGESTION_DATA[type].filter(item => 
    String(item ?? '').toLowerCase().includes(searchTerm)
  ).slice(0, 10); // Limit to 10 suggestions
};

// Function to get suggestions starting with input
export const getSuggestionsStartingWith = (input, type) => {
  if (!SUGGESTION_DATA[type]) return [];
  const raw = String(input ?? '').trim();
  if (!raw) return [];

  const searchTerm = raw.toLowerCase();
  return SUGGESTION_DATA[type].filter(item => 
    String(item ?? '').toLowerCase().startsWith(searchTerm)
  ).slice(0, 10); // Limit to 10 suggestions
};
